/**
 * PRODUCT-154 — sanctioned access to REAL color values.
 *
 * Everything else in the app should consume colors as `var(--wh-*)` strings
 * (via `color-theme.ts`) so they track the active theme through CSS. Some
 * consumers can't: mapbox GL paint properties, canvas/WebGL, and JS color math
 * (`color`/`color-alpha`) all parse the string themselves and choke on
 * `var(...)`. Those read the resolved hex/rgba from here instead. antd's theme
 * seeds are the widest such consumer — cssinjs does colour maths on them; see
 * `src/styles/antdTheme.ts` for that seam and its rules.
 *
 * `rawTheme(resolved)` takes the resolved theme so non-reactive call sites
 * (module-scope utils, mapbox paint built imperatively) can pass it explicitly;
 * `useRawColors()` is the reactive hook for components that must re-render when
 * the theme changes.
 */
import { LIGHT, DARK } from './palette'
import { ResolvedTheme, useResolvedTheme } from '../theme/useThemeMode'

export type { ResolvedTheme }

export function rawTheme(
  resolved: ResolvedTheme = 'light'
): Record<string, string> {
  return resolved === 'dark' ? DARK : LIGHT
}

export function useRawColors(): Record<string, string> {
  return rawTheme(useResolvedTheme())
}
